import React from 'react'

import '../styles/card.css';
import { ReactSVG } from 'react-svg';
import ComingSoonIcon from '../assets/icons/undraw_Waiting__for_you_ldha.svg';

const Card = ({ title, content, disabled }) => {

    const { icon, text } = title;
    
    let data = [];

    for (let property in content) {
        data.push({ ...content[property], key: property });
    }

    return (
        <div className={`card ${disabled && 'disabled'}`}>
            <div className="hover-disabled">
                <ReactSVG
                    src={ComingSoonIcon}
                    beforeInjection={(svg) => {
                        svg.style.width = '120px';
                        svg.style.height = '120px';
                        svg.style.color = '#6C63FF';
                    }}
                    wrapper="span"
                />
                <p>Coming Soon</p>
            </div>

            <div className="card-title">
                <ReactSVG
                    src={icon}
                    beforeInjection={(svg) => {
                        svg.style.width = '120px';
                        svg.style.height = '80px';
                        svg.style.color = '#6C63FF';
                    }}
                    wrapper="span"
                />
                <h3>{text}</h3>
            </div>

            {data.map(value => {
                return (
                    <div className="card-content" key={value.key}>
                        <h4>{value.title}</h4>

                        {value.content && <p>{value.content}</p>}

                        {value.list && 
                            <ul>
                                <li>{value.list}</li>
                            </ul>
                        }
                    </div>
                )
            })}
        </div>
    )
}

Card.defaultProps = {
    title: { icon: '' },
    content: '',
    disabled: false,
}

export default Card;
